

import { Component, Vue } from 'vue-property-decorator';
import { UserLogsModule } from '~/store/modules/userLogs';
import { UserModule } from '~/store/modules/user';
import ContentFilter from '~common-components/Popup/Common/ContentFilter.vue';
import ContentDownloader from '~common-components/Popup/Common/ContentDownloader.vue';

@Component({
    components: {
        ContentFilter,
        ContentDownloader,
    },
})
export default class ShowDevicesPopupHeader extends Vue {
    get fileData() {
        return JSON.stringify(UserLogsModule.logs) || 'No user logs';
    }
    get fileName() {
        return `userLog-${UserModule.userMail}.txt`;
    }
}
